import React, { useEffect, useState } from 'react';
import { Alert, Button, Space, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { uploadFestivalPhoto } from '../pages/FestivalPhotos';

export default function FestivalPhotoReminder() {
  const [list, setList] = useState([]);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem('festPhotoRemHide') === new Date().toDateString());
  const navigate = useNavigate();

  const load = () => api.get('/festivals/photo-reminders').then(r => setList(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 10 * 60 * 1000); return () => clearInterval(t); }, []);

  if (hidden || !list.length) return null;

  const upload = async (id, file) => {
    try { await uploadFestivalPhoto(id, file); message.success('Photo save ho gayi'); load(); }
    catch (e) { message.error(e.response?.data?.error || 'Photo upload nahi hui'); }
    return false;
  };

  return (
    <Alert type="warning" showIcon closable style={{ marginBottom: 12, borderRadius: 10 }}
      onClose={() => { sessionStorage.setItem('festPhotoRemHide', new Date().toDateString()); setHidden(true); }}
      message={<b>Tyohar aa raha hai — photo upload karo</b>}
      description={<Space direction="vertical" style={{ width: '100%' }}>
        {list.map(f => (
          <Space key={`${f.id}-${f.date}`} wrap>
            <span>{f.days_left === 0 ? 'Aaj' : `${f.days_left} din baad`} <b>{f.name}</b> hai ({f.date}) — photo upload karo.</span>
            <Upload accept="image/jpeg,image/png,image/webp" showUploadList={false} beforeUpload={(file) => upload(f.id, file)}>
              <Button size="small" type="primary" icon={<UploadOutlined />}>Photo Upload</Button>
            </Upload>
          </Space>
        ))}
        <Button size="small" type="link" style={{ padding: 0 }} onClick={() => navigate('/settings?section=festival-photos')}>Saal ka poora plan dekho</Button>
      </Space>} />
  );
}
